"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
/** Log levels used by the logger. */
var LogLevel;
(function (LogLevel) {
    // No logs
    LogLevel[LogLevel["QUIET"] = 0] = "QUIET";
    // Any error which is fatal to the operation. These errors will force user intervention.
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    // Anything that can potentially cause application oddities, but for which the code can automatically recover.
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    // Generally useful information to log.
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    // Information that is diagnostically helpful to people running the code.
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
